const MUTABLE_FINDER_ENTRY_TYPES = new Set(['finder']);

export function isChartingMutableFinderEntry(entry = {}) {
    return MUTABLE_FINDER_ENTRY_TYPES.has(String(entry?.type || '').trim());
}

export function buildChartingCollectionCacheSignature(entry = {}, finderRevision = 0) {
    const baseSignature = String(entry?.signature || entry?.type || 'finder').trim() || 'finder';

    if (!isChartingMutableFinderEntry(entry)) {
        return baseSignature;
    }

    const normalizedRevision = Math.max(0, Number.parseInt(finderRevision, 10) || 0);

    return `${baseSignature}::finder-${normalizedRevision}`;
}
